export const getConnector = () => {
    return {
        connector: {
            _id: '5d77f95207085632a58945c3',
            name: 'ADP',
            branding: {
                logo: {
                    _id: '5eb62781b4b83f0008f6343c',
                    url: 'https://cdn.atomicfi.com/adp-logo.svg'
                }
            }
        }
    };
};
//# sourceMappingURL=get-connector.js.map